import { render, staticRenderFns } from "./FornecedorCartao.vue?vue&type=template&id=3a00c68e&scoped=true"
import script from "./FornecedorCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./FornecedorCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FornecedorCartao.vue?vue&type=style&index=0&id=3a00c68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a00c68e",
  null
  
)

export default component.exports